import React from 'react'
import './about.css'
import StackImg from '../../assets/stack.png'
import Info from './Info'

const About = () => {
    return (
        <section className='about section' id='about'>
            {/* <h2 className="section__title">
                Acerca de nosotros
            </h2>

            <span className="section__subtitle">
                Introducción
            </span> */}

            <div className='about__container container grid'>
                <img src={StackImg} alt="" className="about__img" />
                <div className='about__data'>
                    <Info />

                    <p className='about__description'>
                    Somos un grupo de profesionales en Sistemas Computacionales con sólida formación y experiencia en el desarrollo y gestión de soluciones tecnológicas.
                    </p>

                    <a href='#contact' className='button button--flex'>
                        Conversemos {/* <i className='bx bxs-file-pdf'></i> */}
                    </a>
                </div>
            </div>
        </section>
    )
}

export default About
